import styles from "./StatsList.module.scss";
import { StatsItem, StatsItemProps } from "../stats-item";
import {
  AiFillHome,
  AiFillSignal,
  AiOutlineDollar,
  AiOutlineEdit,
  AiOutlineFileProtect,
  AiOutlineLineChart,
  AiOutlineSetting,
  AiOutlineSolution,
} from "react-icons/ai";
import { StatsTotalItem } from "../stats-total-item";
import { useCompanyOfficeRequests, useITDepartmentRequests } from "../../hooks";
import { compareRequestStatus } from "../../../utils";

const statsList: Array<StatsItemProps> = [
  {
    icon: <AiOutlineLineChart size={30} color="gray" />,
    link: {
      title: "Danh sách",
      toPath: "/procedure/statistics",
    },
    status: "",
    primaryNumber: 0,
    secondaryNumber: 0,
    department: "Phòng Tổ chức và nhân lực",
  },
  {
    icon: <AiFillSignal size={30} color="gray" />,
    link: {
      title: "Danh sách",
      toPath: "/procedure/statistics",
    },
    status: "",
    primaryNumber: 0,
    secondaryNumber: 0,
    department: "Phòng Kế hoạch đầu tư",
  },
  {
    icon: <AiOutlineFileProtect size={30} color="gray" />,
    link: {
      title: "Danh sách",
      toPath: "/procedure/statistics",
    },
    status: "",
    primaryNumber: 0,
    secondaryNumber: 0,
    department: "Trung tâm kiểm soát tải",
  },
  {
    icon: <AiOutlineDollar size={30} color="gray" />,
    link: {
      title: "Danh sách",
      toPath: "/procedure/statistics",
    },
    status: "",
    primaryNumber: 0,
    secondaryNumber: 0,
    department: "Phòng Tài chính kế toán",
  },
  {
    icon: <AiOutlineSolution size={30} color="gray" />,
    link: {
      title: "Danh sách",
      toPath: "/procedure/statistics",
    },
    status: "",
    primaryNumber: 0,
    secondaryNumber: 0,
    department: "Trung tâm đào tạo",
  },
];

export const StatsList = () => {
  const { isLoading: isITDepartmentLoading, allITDepartmentRequests } =
    useITDepartmentRequests();

  const { isLoading: isCompanyOfficeLoading, allCompanyOfficeRequests } =
    useCompanyOfficeRequests();

  const submittedStatusITDepartmentRequests = allITDepartmentRequests.filter(
    (e) => {
      return compareRequestStatus(e.fields.eRequestStatus, "Submitted");
    }
  );
  const submittedStatusCompanyOfficeRequests = allCompanyOfficeRequests.filter(
    (e) => {
      return compareRequestStatus(e.fields.eRequestStatus, "Submitted");
    }
  );

  const totalAllRequests =
    allITDepartmentRequests.length + allCompanyOfficeRequests.length;

  const isStatsAllLoading = isITDepartmentLoading || isCompanyOfficeLoading;

  return (
    <div className={styles.container}>
      <StatsTotalItem
        loading={isStatsAllLoading}
        icon={<AiFillHome size={30} color="gray" />}
        primaryNumber={totalAllRequests}
      />
      <StatsItem
        loading={isITDepartmentLoading}
        icon={<AiOutlineSetting size={30} color="gray" />}
        link={{
          title: "Danh sách",
          toPath: "/procedure/statistics/information-technology",
        }}
        status=""
        department="Phòng Công nghệ thông tin"
        primaryNumber={allITDepartmentRequests.length}
        secondaryNumber={submittedStatusITDepartmentRequests.length}
      />
      <StatsItem
        loading={isCompanyOfficeLoading}
        icon={<AiOutlineEdit size={30} color="gray" />}
        link={{
          title: "Danh sách",
          toPath: "/procedure/statistics/company-office",
        }}
        status=""
        department="Văn phòng công ty"
        primaryNumber={allCompanyOfficeRequests.length}
        secondaryNumber={submittedStatusCompanyOfficeRequests.length}
      />
      {statsList.map((item, idx) => (
        <StatsItem key={idx} {...item} />
      ))}
    </div>
  );
};
